<template>
  <div class="teacher-item-language w-full text-overflow-dots">
    <BaseIcon
      :name="iconName"
      :color="iconColor ? iconColor : color"
      size="xs"
    />
    <div class="flex-1 flex items-center">
      <div :class="{ label: lightWeight }">
        {{ $t('labels.speaks') }}:
      </div>
      <div
        class="teacher-item-language__item pl-2"
      >
        <span>{{ languagesText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TeacherListItemsLanguage',
  inject: ['teacher'],
  props: {
    iconName: {
      type: String,
      default: 'translate'
    },
    iconColor: {
      type: String,
      default: ''
    },
    lightWeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('local', ['getTutorListDesignColor']),
    color () {
      return this.teacher?.designColor || this.getTutorListDesignColor
    },
    languages () {
      return this.teacher.language?.speaking
    },
    languagesText () {
      const c = this.languages.slice(0, 2)
      let text = ''
      if (c[0]) {
        text = c[0].name
        if (c[1]) {
          text += ', '
          text += c[1].name
        }
        if (this.languages.length > 2) {
          text += '... +' + this.diffList
        }
      }

      return text
    },
    diffList () {
      return Math.abs(this.languages.length - 2)
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.teacher-item-language {
  @apply inline-flex items-center space-x-2 overflow-hidden whitespace-nowrap;
  max-width: max-content;
  &__item {
    @apply  flex items-center space-x-1;
    > span {
      @apply text__headline-5-xs--semibold lg:text__body-2-xs--semibold text-body-1;
    }
  }
  .label {
    @apply text__headline-5-xs--regular lg:text__body-2-xs--regular text-body-2
  }
}
</style>
